import { apiSlice } from "../apiSlice";

const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PROD;

export interface Holiday {
  id?: string;
  reason: string;
  date: {
    seconds: number;
    nanoseconds: number;
  };
  openTime?: {
    seconds: number;
    nanoseconds: number;
  };
  closeTime?: {
    seconds: number;
    nanoseconds: number;
  };
  isFullDay: boolean;
  createdAt?: {
    seconds: number;
    nanoseconds: number;
  };
  updatedAt?: {
    seconds: number;
    nanoseconds: number;
  };
}

export interface GetHolidaysRequest {
  restaurantId: string;
}

export type GetHolidaysResponse = Holiday[];

export interface SaveHolidayRequest {
  restaurantId: string;
  holidayId?: string; // Present for update, absent for add
  reason: string;
  dateTime: string;
  shopOpenTime?: string;
  shopCloseTime?: string;
  isFullDay: boolean;
}

export interface SaveHolidayResponse {
  holidayId: string;
  createdAt: {
    seconds: number;
    nanoseconds: number;
  };
  date: {
    seconds: number;
    nanoseconds: number;
  };
  openTime?: {
    seconds: number;
    nanoseconds: number;
  };
  closeTime?: {
    seconds: number;
    nanoseconds: number;
  };
  updatedAt: {
    seconds: number;
    nanoseconds: number;
  };
  isFullDay: boolean;
  reason: string;
}

export interface DeleteHolidayRequest {
  restaurantId: string;
  holidayId: string;
}

export interface DeleteHolidayResponse {
  message: string;
}

export const holidayApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Get all holidays
    getHolidays: builder.query<GetHolidaysResponse, GetHolidaysRequest>({
      query: ({ restaurantId }) => ({
        url: `https://adminhttps-getholidaysbyrestaurantid${API_BASE_DOMAIN}?restaurantId=${restaurantId}`,
        method: "GET",
      }),
      providesTags: ["Holidays"],
    }),

    // Save holiday (Add or Update)
    saveHoliday: builder.mutation<SaveHolidayResponse, SaveHolidayRequest>({
      query: (body) => ({
        url: `https://adminhttps-saverestaurantholiday${API_BASE_DOMAIN}`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Holidays"],
    }),

    // Delete holiday
    deleteHoliday: builder.mutation<DeleteHolidayResponse, DeleteHolidayRequest>({
      query: ({ restaurantId, holidayId }) => ({
        url: `https://adminhttps-deleterestaurantholiday${API_BASE_DOMAIN}?restaurantId=${restaurantId}&holidayId=${holidayId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Holidays"],
    }),
  }),
});

export const {
  useGetHolidaysQuery,
  useLazyGetHolidaysQuery,
  useSaveHolidayMutation,
  useDeleteHolidayMutation,
} = holidayApi;
